/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * API specification of ZoomAPI
 *
 * @class ZoomAPISpec
 * @private
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class ZoomAPISpec {
		getAPISpec() {
			if (!this.apiSpec) {
				this.apiSpec = {
					name: 'Zoom API',
					events: {
						actions: {
							setZoomLevel: {
								eventName: 'zoomLevel',
								getInfo(args) {
									return { value: args[0] };
								}
							}
						}
					}
				};
			}
			return this.apiSpec;
		}
	}
	return ZoomAPISpec;
});
